module.exports = __webpack_public_path__ + "static/img/9.0a67fb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/9.png
// module id = X13z
// module chunks = 0